import { subscribeToActivity } from "./activityIndicator";

// Mirrors the in-flight Firestore read count onto <body> as a class, so plain
// CSS can tell "still loading" apart from "genuinely empty".
//
// The react-table empty state (utils/reactTableDefaults.js) can subscribe to
// the activity counter directly because it is a React component. The app's 36
// hand-rolled `<table>` pages have no such component — their `<tbody>` is just
// `{rows.map(...)}`, which renders nothing at all when the array is empty. The
// only way to give those an empty state without editing 36 files is a CSS rule
// on `tbody:empty`, and CSS cannot read a JS counter. This is the bridge.
//
// Registered once from index.js, alongside the react-table defaults.
export const BUSY_CLASS = "alg-busy";

subscribeToActivity((busy) => {
  if (typeof document === "undefined" || !document.body) return;
  document.body.classList.toggle(BUSY_CLASS, busy);
});
